export default __webpack_public_path__ + "static/media/style_component.186b514d.png";